import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { IconEye, IconEyeOff } from './Icon';

/**
 * Campo de senha com o olho para revelar o que foi digitado. No celular,
 * digitar uma senha às cegas num teclado pequeno é a maior fonte de "senha
 * incorreta" — e no cadastro, de conta criada com a senha errada.
 */
function PasswordInput({ className = '', ...props }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`auth-password ${className}`}>
      <Form.Control {...props} type={visible ? 'text' : 'password'} className="auth-input" />
      <button
        type="button"
        className="auth-password-toggle"
        onClick={() => setVisible((v) => !v)}
        // Sem rótulo o leitor de tela anuncia só "botão"; o title cobre o mouse.
        aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
        title={visible ? 'Ocultar senha' : 'Mostrar senha'}
        // Fora da ordem de tabulação: entre a senha e o botão de entrar, o
        // teclado pararia num controle que ninguém procura ali.
        tabIndex={-1}
      >
        {visible ? <IconEyeOff size={18} /> : <IconEye size={18} />}
      </button>
    </div>
  );
}

export default PasswordInput;
